import { CircleIcon } from '../../Atoms';
import './TagsInfo.css';

const TagsInfo = ({ title, descriptionTitle, subtitle, descriptionSub, iconTitle, iconSub }) => {
  return (
    <div className="detail-course d-lg-flex d-flex-lg-row d-none mt-4 py-3">
      <div className="item-tag-detail">
        <div className="icon d-flex flex-column pe-4">
          <CircleIcon img={iconTitle} />
        </div>
        <div className="d-flex flex-column pe-3">
          <span>{title ?? 'Modalidad'}</span>

          <b>{descriptionTitle ?? 'En línea y en vivo'}</b>
        </div>
      </div>
      <div className="footer-section-divider"></div>
      <div className="item-tag-detail">
        <div className="icon px-4">
          <CircleIcon img={iconSub} />
        </div>
        <div className="d-flex flex-column">
          <span>{subtitle ?? 'Aprendizaje'}</span>
          <b>{descriptionSub ?? 'Experencial'}</b>
        </div>
      </div>
    </div>
  );
};

export default TagsInfo;
